import type { NavigationLink } from "@hooks/useNavigationLinks"

import type { SideBarItemProps } from "@organisms/SideBar/components/SideBarItem/SideBarItem.types"

export default function filterUserLinks<LinkType extends SideBarItemProps | NavigationLink>(
    links: LinkType[] | undefined,
    user: User | null,
): LinkType[] {
    return (links ?? []).filter((link) => !link.predicate || (user ? link.predicate(user) : false))
}
